module.exports = __webpack_public_path__ + "static/media/novaka-logo-login.ec976c63.svg";